// extracted by mini-css-extract-plugin
module.exports = {"badge":"style__badge___3SRp9 reset__reset___2e25U"};